import script from "./ShowWordsForTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowWordsForTask.vue?vue&type=script&setup=true&lang=js"

import "./ShowWordsForTask.vue?vue&type=style&index=0&id=e5cb94fc&lang=scss"
import "./ShowWordsForTask.vue?vue&type=style&index=1&id=e5cb94fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5cb94fc"]])

export default __exports__